(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["language-picker"]) return;
  try {
    
  class LanguagePicker extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.language-picker__toggle');
      this.menu = this.querySelector('.language-picker__menu');

      if (!this.toggle || !this.menu) return;

      this.onToggleClick = this.onToggleClick.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onDocumentKeydown = this.onDocumentKeydown.bind(this);

      this.toggle.addEventListener('click', this.onToggleClick);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onDocumentKeydown);
    }

    disconnectedCallback() {
      if (this.toggle) {
        this.toggle.removeEventListener('click', this.onToggleClick);
      }

      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onDocumentKeydown);
    }

    onToggleClick(event) {
      event.stopPropagation();
      this.classList.contains('is-open') ? this.close() : this.open();
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.close();
      }
    }

    onDocumentKeydown(event) {
      if (event.key === 'Escape' && this.classList.contains('is-open')) {
        this.close();
        this.toggle.focus();
      }
    }

    open() {
      this.classList.add('is-open');
      this.menu.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.classList.remove('is-open');
      this.menu.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('language-picker')) {
    customElements.define('language-picker', LanguagePicker);
  }

  } catch(e) { console.error(e); }
})();
})();
